<template>
  <div class="row mb-2">
    <div class="col-6 col-md-4 col-lg-2">
      <b-form-group
        label="Felszereltségi szint"
        label-for="typename2"
      >
        <b-form-select
          id="typename2"
          v-model="filter.typename2"
          :options="typename2s"
          size="sm"
        />
      </b-form-group>
    </div>
    <div class="col-6 col-md-4 col-lg-2">
      <b-form-group
        label="Teljesítmény"
        label-for="ph"
      >
        <b-form-select
          id="ph"
          v-model="filter.ph"
          :options="phs"
          size="sm"
        />
      </b-form-group>
    </div>
    <div class="col-6 col-md-4 col-lg-2">
      <b-form-group
        label="Üzemanyag"
        label-for="fuelType"
      >
        <b-form-select
          id="fuelType"
          v-model="filter.fuelType"
          :options="fuelTypes"
          size="sm"
        />
      </b-form-group>
    </div>
    <div class="col-6 col-md-4 col-lg-2">
      <b-form-group
        label="Váltó"
        label-for="transType"
      >
        <b-form-select
          id="transType"
          v-model="filter.transType"
          :options="transTypes"
          size="sm"
        />
      </b-form-group>
    </div>
    <div class="col-6 col-md-4 col-lg-2">
      <b-form-group
        label="Ülések száma"
        label-for="TCOCo2EmiV2"
      >
        <b-form-select
          id="seats"
          v-model="filter.seats"
          :options="seats"
          size="sm"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const typeModule = namespace('type');

  @Component
  export default class TypeFilter extends Vue {
    filter = {
      typename2: '',
      ph: '',
      fuelType: '',
      transType: '',
      seats: ''
    };

    @Prop() types;
    @typeModule.Getter('getItems') items;
    @typeModule.Getter('getTypeName2s') typename2s;
    @typeModule.Getter('getPhs') phs;
    @typeModule.Getter('getFuelTypes') fuelTypes;
    @typeModule.Getter('getTransTypes') transTypes;
    @typeModule.Getter('getSeats') seats;
    @typeModule.Action('fetchAll') fetchAll;
    @typeModule.Action('applyFilter') applyFilter;

    created() {
      this.fetchAll(this.types);
    }

    @Watch('filter', {deep: true})
    onFilterChanged() {
      this.applyFilter(this.filter);
    }
  }
</script>
